import { Loading } from '@common/general-ui/loading/loading.component';
import { RenderRoutes } from '@common/general-ui/render-routes/render-routes.component';
import { authService } from '@common/services/auth.service';
import { GET_REGISTER_ROUTES } from '@src/features/register/register-routes.constant';
import { LINKS } from '@src/shared/links.constant';
import React, { useMemo } from 'react';

interface IProps {
    isLoading: boolean;
}

export const RegisterRoutes = ({ isLoading }: IProps): JSX.Element => {
    const config = useMemo(() => GET_REGISTER_ROUTES(), []);
    return (
        <Loading isLoading={isLoading}>
            {!isLoading && (
                <RenderRoutes
                    loginUrl={LINKS.auth.login}
                    dontHavePermissionUrl={LINKS.other.dontHavePermission}
                    config={config}
                    getToken={(): string | undefined => authService.getInfo()?.id_token}
                />
            )}
        </Loading>
    );
};
